import { Injectable } from '@angular/core';
import { Router } from '@angular/router';
import { Observable, of } from 'rxjs';

@Injectable()
export class PreLoginAuthenticationGuard {
  constructor(private router: Router) {}

  canActivate(): Observable<boolean> {
    this.router.navigateByUrl('/public/login');

    return of(false);
  }
}
